import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  Platform,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  aboutAuthor,
  pageContent,
  pageCover,
  Colors,
  Typo,
  FontFamily,
  article,
} from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";
import TouchableOpacityLinkExternal from "../touchable-opacity-link-external";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";
import { helpers } from "../../utils/helpers";
// import '../../../cssFile/gradienttext.css'

const angleIcon = getImagePath("icons/angle-icon.png");
const cross = getImagePath("icons/cross.png");
const blackDots = getImagePath("icons/black-dots.png");
const pinkDots = getImagePath("icons/pink-dots.png");

export class OurMission extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {};

  render() {
    let { darkMode } = this.props;
    let webView = helpers.isWeb();
    return (
      <View
        style={[
          Helpers.textCenter,
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWeb1000,
          {
            marginTop: helpers.isDesktop() ? 70 : 75,
            paddingHorizontal: helpers.isDesktop() ? 20 : 0,
            width: helpers.isDesktop() ? "85%" : "100%",
          },
        ]}
      >
        {/* <View style={[article.headerWrapper, !helpers.isDesktop() && { position: 'absolute' }, !helpers.isDesktop() && { left: 0 }, !helpers.isDesktop() && { right: 0 }, !helpers.isDesktop() && { top: 0 }]}>
                        <View style={[Flex.alignCenter, Margin.mb_5, !helpers.isDesktop() && Margin.mb_4]}>
                            <View style={[Padding.ph_2, Helpers.titleBgWrap, helpers.isDesktop() && { backgroundColor: darkMode ? Colors.darkBlackColor : '#FFF9F1' }, !helpers.isDesktop() &&  { backgroundColor: darkMode ? Colors.darkBlackColorBg :'#FFFBF1' },{marginTop:20}]}>
                            <Text style={[Margin.mt_0, Margin.mb_0, pageCover.title, helpers.isDesktop() && pageCover.titleDesktop,  Helpers.textCenter,{position:'relative',color: '#051462', top: helpers.isDesktop() ? -37 : -18}, !helpers.isDesktop() && { fontSize: 30 }, darkMode && {color: Colors.lightWhite}]}>Our journalism</Text>

                            </View>
                            <View style={[Helpers.titleLine, darkMode && { backgroundColor: Colors.lineColor  }]}></View>
                        </View>
                    </View> */}
        {/* <Text style={[Margin.mt_0, Margin.mb_0, pageCover.title, helpers.isDesktop() && pageCover.titleDesktop,  Helpers.textCenter,{position:'relative',color: '#051462', top: helpers.isDesktop() ? -37 : -18}, !helpers.isDesktop() && { fontSize: 30 }, darkMode && {color: Colors.lightWhite}]}>Our journalism</Text> */}
        <View
          style={[
            article.headerWrapper,
            !helpers.isDesktop() && { position: "absolute" },
            !helpers.isDesktop() && { left: 0 },
            !helpers.isDesktop() && { right: 0 },
            !helpers.isDesktop() && { top: 0 },
          ]}
        >
          <View
            style={[
              Flex.alignCenter,
              Margin.mb_5,
              !helpers.isDesktop() && Margin.mb_4,
            ]}
          >
            <View
              style={[
                Padding.ph_2,
                Helpers.titleBgWrap,
                helpers.isDesktop() && {
                  backgroundColor: darkMode ? Colors.darkBlackColor : "#FFF",
                },
                !helpers.isDesktop() && {
                  backgroundColor: darkMode ? Colors.darkBlackColorBg : "#FFF",
                },
                { marginTop: helpers.isDesktop() ? 20 : 0 },
              ]}
            >
              <View>
                <Text
                  style={[
                    Margin.mt_0,
                    Margin.mb_0,
                    pageCover.title,
                    helpers.isDesktop() && pageCover.titleDesktop,
                    helpers.isDesktop() && { bottom: 15 },
                    Helpers.textCenter,
                    { position: "relative", color: "#051462" },
                    !helpers.isDesktop() && {
                      fontSize: helpers.isDesktop() ? 30 : 28,
                    },
                    darkMode && { color: Colors.lightWhite },
                  ]}
                >
                  Our journalism
                </Text>
              </View>
            </View>
            {helpers.isDesktop() && (
              <View
                style={[
                  Helpers.titleLine,
                  darkMode && { backgroundColor: "#F3F5FF" },
                ]}
              ></View>
            )}
          </View>
        </View>
        {helpers.isDesktop() ? (
          <Text
            accessibilityRole="header"
            aria-level="2"
            style={[
              { marginBottom: 0, lineHeight: 28, letterSpacing: 0.3 },
              pageContent.subTitle,
              helpers.isDesktop() && pageContent.subTitleDesktop,
              {
                maxWidth: helpers.isDesktop() ? 700 : "100%",
                fontSize: helpers.isDesktop() ? 24 : 16,
              },
              !webView && { textAlign: "center" },
              darkMode && { color: Colors.lightWhite },
            ]}
          >
            The Morning Context makes you smarter with original, accurate and
            independent journalism.
            {/* <div style={{ display: "inline" }} class="gradient-text">
              independent credible
            </div>{" "}
            media company, which tells{" "}
            <div style={{ display: "inline" }} class="gradient-text">
              stories that matter.
            </div> */}
          </Text>
        ) : (
          <Text
            accessibilityRole="header"
            aria-level="2"
            style={[
              {
                marginBottom: 90,
                marginTop: 45,
                lineHeight: 28,
                letterSpacing: 0.3,
              },
              pageContent.subTitle,
              helpers.isDesktop() && pageContent.subTitleDesktop,
              {
                maxWidth: helpers.isDesktop() ? 700 : "100%",
                fontSize: helpers.isDesktop() ? 24 : 16,
              },
              !webView && { textAlign: "center" },
              darkMode && { color: Colors.lightWhite },
            ]}
          >
            The Morning Context makes you smarter with original, accurate and
            independent journalism.
            {/* <div style={{ display: "inline" }} class="gradient-text">
              independent credible{"\n"}
            </div>{" "}
            media company, which tells{"\n"}{" "}
            <div style={{ display: "inline" }} class="gradient-text">
              stories that matter.
            </div> */}
          </Text>
        )}
      </View>
    );
  }
}

export default OurMission;
